/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { useGridApiRef, GridActionsCellItem } from '@mui/x-data-grid-pro';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';
import AskDialog from '../../../components/common/dialog/AskDialog';

import _ from 'lodash';

import * as productApi from '../../../lib/api/product';

import BaseCodeSelectbox from '../../../components/common/datagrid/BaseCodeSelectbox';
import {
  listPartnerProductPrices,
  unloadPartnerProductPrices,
} from '../../../modules/partnerModule/productprices';
import PartnerProductPriceList from '../../../components/partnermng/productprice/ProPriceList';

const ParProductPriceListContainer = ({ type }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  // const [searchData, setSearchData] = useState(null);

  const { partner, productprices, error, loading } = useSelector(
    ({ partnerModule, loading }) => ({
      partner: partnerModule.partner.partner,
      productprices: partnerModule.partnerProductPrices.productprices,
      error: partnerModule.partnerProductPrices.error,
      loading: loading['product/LIST_PARTNER_PRODUCT_PRICES'],
    }),
  );

  useEffect(() => {
    if (partner) {
      let searchData = { pricePartnerUuid: partner.partnerUuid };
      // setSearchData({ 'pricePartnerUuid': partner.partnerUuid })

      dispatch(listPartnerProductPrices(searchData));
    }

    //언마운트될때 리덕스에서 파트너 데이터 초기화
    return () => {
      dispatch(unloadPartnerProductPrices());
    };
  }, [partner]);

  const apiRef = useGridApiRef();

  const handleRowEditStart = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const handleRowEditStop = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const handleCellFocusOut = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const handleEditClick = (id) => (event) => {
    event.stopPropagation();
    apiRef.current.setRowMode(id, 'edit');
  };

  const handleSaveClick = (id) => (event) => {
    event.stopPropagation();
    apiRef.current.commitRowChange(id);
    apiRef.current.setRowMode(id, 'view');

    const row = apiRef.current.getRow(id);

    //edit api call
    onSave(row);
  };

  const onSave = async (row) => {
    let dataToSubmit = {
      productUuid: row.productUuid,
      priceUuid: row.id,
      partnerUuid: partner.partnerUuid, //판매업체
      priceTyp: row.priceTyp,
      priceVal: row.priceVal,
      priceDesc: row.priceDesc,
      useYn: row.useYn,
    };

    try {
      const response = await productApi.editProductPrices(
        row.productUuid,
        dataToSubmit,
      );

      if (response.data.result === 'success') {
        let searchData = { pricePartnerUuid: partner.partnerUuid };
        dispatch(listPartnerProductPrices(searchData));
        enqueueSnackbar('제품 가격정보를 저장하였습니다', {
          variant: 'success',
        });
      }
    } catch (err) {
      apiRef.current.updateRows([{ ...row, isNew: false }]);
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  const handleCancelClick = (id) => (event) => {
    event.stopPropagation();
    apiRef.current.setRowMode(id, 'view');

    const row = apiRef.current.getRow(id);
    if (row.isNew) {
      apiRef.current.updateRows([{ id, _action: 'delete' }]);
    }
  };

  const [removeRow, setRemoveRow] = useState(null);
  const handleDeleteClick = (id) => (event) => {
    event.stopPropagation();

    //remove 작업
    setVisible(true);
    const row = apiRef.current.getRow(id);
    setRemoveRow(row);
  };

  const onRemove = async () => {
    try {
      const response = await productApi.removeProductPrice(
        removeRow.productUuid,
        removeRow.id,
      );
      if (response.data) {
        apiRef.current.updateRows([{ id: removeRow.id, _action: 'delete' }]);
        enqueueSnackbar('삭제 성공', {
          variant: 'success',
        });
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
    setRemoveRow(null);
  };

  const renderEditPriceTyp = (params) => {
    params.filterObject = {
      blcCd: 'BASE',
      mlcCd: 'PRODUCT',
      slcCd: 'PRICE_TYP',
      useYn: 'Y',
    };
    params.name = 'priceTyp';
    return <BaseCodeSelectbox {...params} />;
  };

  const columns = useMemo(
    () => [
      {
        field: 'id',
        headerName: 'ID',
        hide: true,
        type: 'string',
        editable: false,
      },
      {
        field: 'priceUuid',
        hide: true,
        type: 'string',
        editable: false,
      },
      {
        field: 'productUuid',
        hide: true,
        type: 'string',
        editable: false,
      },
      {
        field: 'pricePartnerUuid', //판매처
        type: 'string',
        editable: false,
        hide: true,
      },
      {
        field: 'partnerUuid', //제조업체
        type: 'string',
        editable: false,
        hide: true,
      },
      {
        field: 'productNm',
        headerName: '제품명',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: false,
      },
      {
        field: 'modelNm',
        headerName: '모델명',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: false,
      },
      {
        field: 'partnerNm',
        headerName: '제조업체',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: false,
      },
      {
        field: 'category',
        headerName: '분류',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: false,
      },
      {
        field: 'priceTyp',
        headerName: '가격타입',
        minWidth: 150,
        flex: 0.7,
        type: 'string',
        editable: true,
        renderEditCell: renderEditPriceTyp,
      },
      {
        field: 'priceVal',
        headerName: '가격',
        minWidth: 120,
        flex: 0.6,
        type: 'number',
        editable: true,
        valueFormatter: (params) => {
          const valueFormatted = Number(params.value).toLocaleString('ko-KR');
          return `₩ ${valueFormatted}`;
        },
      },

      {
        field: 'priceDesc',
        headerName: '가격 사양설명',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: true,
      },
      {
        field: 'useYn',
        headerName: '사용유무',
        minWidth: 80,
        flex: 0.3,
        type: 'boolean',
        editable: true,
      },
      {
        field: 'cngNm',
        headerName: '수정자',
        minWidth: 80,
        flex: 0.3,
        type: 'string',
        editable: false,
      },
      {
        field: 'cngDt',
        headerName: '수정일',
        minWidth: 120,
        flex: 0.6,
        type: 'dateTime',
        editable: false,
      },
      {
        field: 'actions',
        type: 'actions',
        headerName: 'Actions',
        width: 100,
        cellClassName: 'actions',
        getActions: ({ id }) => {
          const isInEditMode = apiRef.current.getRowMode(id) === 'edit';

          if (isInEditMode) {
            return [
              <GridActionsCellItem
                icon={<SaveIcon />}
                label="Save"
                onClick={handleSaveClick(id)}
                color="primary"
              />,
              <GridActionsCellItem
                icon={<CancelIcon />}
                label="Cancel"
                className="textPrimary"
                onClick={handleCancelClick(id)}
                color="inherit"
              />,
            ];
          }

          return [
            <GridActionsCellItem
              icon={<EditIcon />}
              label="Edit"
              className="textPrimary"
              onClick={handleEditClick(id)}
              color="inherit"
            />,
            <GridActionsCellItem
              icon={<DeleteIcon />}
              label="Delete"
              onClick={handleDeleteClick(id)}
              color="inherit"
            />,
          ];
        },
      },
    ],
    [apiRef, handleEditClick, handleSaveClick, handleCancelClick],
  );

  const [visible, setVisible] = useState(false);

  const onCancle = () => {
    setVisible(false);
    setRemoveRow(null);
  };

  const onConfirm = () => {
    setVisible(false);
    onRemove();
  };

  return (
    <>
      <PartnerProductPriceList
        apiRef={apiRef}
        columns={columns}
        rows={productprices}
        error={error}
        loading={loading}
        handleRowEditStart={handleRowEditStart}
        handleRowEditStop={handleRowEditStop}
        handleCellFocusOut={handleCellFocusOut}
      />
      <AskDialog
        visible={visible}
        title="제품 가격 삭제"
        description="선택한 제품 가격를 삭제하시겠습니까?"
        confirmText="삭제"
        onConfirm={onConfirm}
        onCancle={onCancle}
      />
    </>
  );
};

export default ParProductPriceListContainer;
